import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Button } from './Button';
const CHECKOUT_URL = 'https://www.lunaycalma.com/cart/46841754419354:1';
export function GuaranteeSection() {
  return <section className="w-full py-20 bg-gradient-to-br from-navy-900 to-teal-900 text-white" data-id="element-163">
      <div className="max-w-4xl mx-auto px-6" data-id="element-164">
        <div className="text-center mb-12" data-id="element-165">
          <div className="inline-block mb-6" data-id="element-166">
            <ShieldCheckIcon className="w-20 h-20 text-emerald-400" data-id="element-167" />
          </div>

          <h2 className="font-serif text-4xl lg:text-5xl mb-6" data-id="element-168">
            Garantía de 7 días
          </h2>

          <p className="text-xl text-gray-200 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-169">
            Si en los próximos 7 días no sientes más claridad y control sobre tu
            dinero, te devolvemos tu dinero.
          </p>

          <p className="text-2xl font-bold text-emerald-400 mb-8" data-id="element-170">
            Sin preguntas. Sin riesgo.
          </p>
        </div>

        <div className="bg-white/10 rounded-3xl p-8 lg:p-12 backdrop-blur-sm mb-8" data-id="element-171">
          <h3 className="font-serif text-3xl text-center mb-8" data-id="element-172">
            Este no es el final
          </h3>
          <p className="text-2xl text-center font-bold text-emerald-400 mb-8" data-id="element-173">
            Es el primer paso
          </p>

          <p className="text-lg text-gray-200 text-center mb-6" data-id="element-174">
            El paso donde:
          </p>

          <div className="grid md:grid-cols-2 gap-6 max-w-2xl mx-auto mb-8" data-id="element-175">
            <div className="text-center" data-id="element-176">
              <p className="text-lg" data-id="element-177">Dejas de reaccionar</p>
            </div>
            <div className="text-center" data-id="element-178">
              <p className="text-lg" data-id="element-179">Empiezas a elegir</p>
            </div>
            <div className="text-center" data-id="element-180">
              <p className="text-lg" data-id="element-181">Recuperas calma</p>
            </div>
            <div className="text-center" data-id="element-182">
              <p className="text-lg" data-id="element-183">Construyes base</p>
            </div>
          </div>

          <p className="text-2xl font-bold text-center text-white mb-8" data-id="element-184">
            👉 Empieza hoy.
          </p>
        </div>

        <div className="text-center" data-id="element-185">
          <Button size="lg" href={CHECKOUT_URL} data-id="element-186">
            👉 Quiero dejar de sufrir cada quincena
          </Button>
          <p className="text-sm text-gray-400 mt-6" data-id="element-187">
            Compra 100% segura • Garantía de 7 días
          </p>
        </div>
      </div>
    </section>;
}